import {
  MaterialUICore,
  axiomTokens,
  Button as DSButton,
  Box as DSBox,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { spacing, color } = axiomTokens;

export const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  marginTop: spacing[2],
});

export const FieldsWrapper = styled('div')(({ theme }) => ({
  gap: spacing[4],
  gridTemplateColumns: '1fr 1fr 1fr 1fr',
  gridTemplateAreas: `
      "person_kind person_kind cep cep"
      "address address address number"
      "complement neighborhood neighborhood neighborhood"
      "city city city state"
      "document document birthdate birthdate"
      "responsible responsible responsible responsible"
    `,
  display: 'grid',

  [theme.breakpoints.down('xs')]: {
    gridTemplateColumns: '1.3fr 1fr',
    gridTemplateAreas: `
      "person_kind person_kind"
      "cep cep"
      "address number"
      "complement neighborhood"
      "city state"
      "document document"
      "responsible responsible"
      "birthdate birthdate"
    `,
  },
}));

export const Button = styled(DSButton)({
  color: color.interactive.accent.default,
});

export const Box = styled(DSBox)({
  marginTop: spacing[5],
  gap: spacing[4],
  display: 'flex',
  justifyContent: 'flex-end',
});
